import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { ArrowLeftOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { apiGetPage, apiEditInfo, apiAddInfo } from '../../request/api';
import Pagination from '../paginnation';
import { Modal, message, Button } from 'antd';
import NotHaveInfo from '../nothaveinfo';
import { useCustomData } from '../../pages/context/mineCustomDataProvider';

interface ChooseCompanyProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface invoiceInfo {
    companyName: string;
    companyIdentification: string;
    companyService: string;
    serviceEndTime: string;
    isChoose: boolean;
    id: string;
}

const getLocalUserInfo = () => {
    return {
        userId: localStorage.getItem('userId') || '',
        userName: localStorage.getItem('userName') || '',
        userEmail: localStorage.getItem('userEmail') || '',
        userPhone: localStorage.getItem('userPhone') || '',
    };
};

const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0'); // 添加秒数
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

const ChooseCompany: React.FC<ChooseCompanyProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [invoiceList, setInvoiceList] = useState<invoiceInfo[]>([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const selectedCompanyId = localStorage.getItem('selectedCompanyId') || '';

    const itemsPerPage = 6;
    const totalItems = invoiceList.length;
    const [currentPage, setCurrentPage] = useState(1);
    const [currentProduct, setCurrentProduct] = useState<any>(null);
    const [productList, setProductList] = useState<any[]>([]);

    const { getValue } = useCustomData();
    const complateServiceInfo = getValue('complateServiceInfo');
    const serviceName = getValue('serviceName');
    const serviceVersion = getValue('serviceVersion');
    const serviceType = getValue('serviceType');
    const notnone = getValue('notnone');
    const upload = getValue('upload');
    const taps = getValue('taps');
    const onlypass = getValue('onlypass');
    const serviceEndTime = getValue('serviceEndTime');
    const renew = getValue('renew');
    const upgrade = getValue('upgrade');
    const SelectEnterprise = getValue('SelectEnterprise');
    const currentEnterprise = getValue('currentEnterprise');
    const service = getValue('service');

    useEffect(() => {
        const userId = localStorage.getItem('userId')
        // 获取公司表数据
        Promise.all([
            apiGetPage({
                tid: 'E85B2C2CBF4C45FC89D7D540D35F780F',
                page: 1,
                size: 100,
                search: 'belongToUser:' + userId,
                languagecode: languageCode,
            }),
            apiGetPage({
                tid: '72D99CCB9A7E439184BF9EF7CABC49BA',
                page: 1,
                size: 100,
                search: '',
                languagecode: languageCode,
            })
        ]).then(([companyRes, productRes]) => {
            const companyList = companyRes?.data?.data?.rows || [];
            console.log(companyList)
            const productList = productRes?.data?.data?.rows || [];
            setProductList(productList);

            // 构建商品ID到商品名的映射
            const productMap = new Map<string, string>();
            productList.forEach((product: { id: string; commodityName: any; }) => {
                productMap.set(product.id, product.commodityName || '');
            });

            // 组装最终 invoiceList 并根据 selectedCompanyId 设置 isChoose
            const resultList: invoiceInfo[] = companyList.map((company: {
                id: any; bindProduct: string; componyName: any; uniqueIdentificationNumber: any; serviceEndTime: any;
            }) => {
                const matchedProductName = productMap.get(company.bindProduct) || '未知服务';
                const companyName = company.componyName;

                // 检查此公司是否应该被选中
                const isSelected = selectedCompanyId && company.id === selectedCompanyId;

                return {
                    companyName,
                    companyIdentification: company.uniqueIdentificationNumber,
                    companyService: matchedProductName,
                    serviceEndTime: company.serviceEndTime || '无',
                    id: company.id,
                    isChoose: isSelected
                };
            });

            // 更新列表和选中索引
            setInvoiceList(resultList);

            // 设置选中的索引
            if (selectedCompanyId) {
                const selectedIndex = resultList.findIndex(item => item.id === selectedCompanyId);
                if (selectedIndex !== -1) {
                    setSelectedIndex(selectedIndex);
                }
            } else {
                setSelectedIndex(-1); // 没有选中的公司
            }
        });
    }, []);

    const handleItemClick = (index: number) => {
        const updatedList = invoiceList.map((item, i) => ({
            ...item,
            isChoose: i === index
        }));
        setInvoiceList(updatedList);
        setSelectedIndex(index);
        console.log(updatedList[index].id)
        localStorage.setItem('selectedCompanyId', updatedList[index].id);
    };

    const handleUpgradeClick = (item: invoiceInfo) => {
        const matched = productList.find(product => product.commodityName === item.companyService);
        if (matched) {
            setCurrentProduct(matched);
            setIsModalOpen(true);
        } else {
            messageApi.warning('未找到对应服务信息');
        }
    };

    const addProduct = () => {
        if (!currentProduct?.id) {
            messageApi.error('未找到要提交的服务信息');
            return;
        }

        const { userId, userName, userEmail, userPhone } = getLocalUserInfo();
        const payload = {
            tid: 'DFB8D3686DDD4CE88ED9E7659257B8B4',
            serviceStatus: '升级',
            createdTime: formatDate(new Date()),
            isIntention: '未知',
            chooseUser: `${userId}`,
            contactEmail: userEmail,
            contactPhone: userPhone,
            launchCompany: selectedCompanyId,
            workStatus: '待处理',
            languagecode: languageCode,
            chooseCommodity: currentProduct.id,
        };
        console.log(payload)

        apiAddInfo(payload).then((res) => {
            const { ret, msg } = res.data || {};
            console.log(res)
            if (ret === '0') {
                messageApi.success('提交成功');
                setIsModalOpen(false);
                setCurrentProduct(null);
            } else {
                messageApi.error(msg || '提交失败');
            }
        }).catch(() => {
            messageApi.error('提交异常');
        });
    }

    return (
        <div className="ChooseManagement">
            <style>{`
                :root {
                    --theme-color: ${themeColor};
                }
            `}</style>
            {contextHolder}
            <div className='management-chooselist'>
                {invoiceList.slice((currentPage - 1) * 6, currentPage * itemsPerPage).map((item, index) => (
                    <div
                        key={index}
                        style={{
                            border: `1px solid ${item.isChoose || index === hoveredIndex
                                ? themeColor
                                : '#e5e5ee'
                                }`,
                            transition: 'border-color 0.3s ease' // 可选：添加过渡动画
                        }}
                        className='campany-chooseitem'
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className='campany-header' style={{
                            color: item.isChoose ? themeColor : 'inherit'
                        }}>
                            {item.companyName}
                        </div>
                        <p style={{ marginTop: '13px' }}>{onlypass}：{item.companyIdentification}</p>
                        <p>{service}：{item.companyService}</p>
                        <div className='campany-item-defined'>
                            <span>{serviceEndTime}：{item.serviceEndTime}</span>
                            <span className="upgrade-button" style={{ color: themeColor }} onClick={() => handleUpgradeClick(item)}>{upgrade}</span>
                        </div>
                        <div
                            className="companyIsChoose"
                            style={{
                                backgroundColor: item.isChoose ? themeColor : '#f6f6f8',
                                color: item.isChoose ? '#ffffff' : '#33364b',
                                marginTop: '20px',
                                padding: '8px 0',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s', // 添加过渡动画
                                // 悬停效果（非选中状态时）
                                ...(!item.isChoose && {
                                    ':hover': {
                                        backgroundColor: themeColor // 自定义悬停颜色
                                    }
                                })
                            }}
                            onClick={() => handleItemClick(index)}
                        >
                            {item.isChoose ? currentEnterprise : SelectEnterprise}
                        </div>
                    </div>
                ))}
                {invoiceList.length === 0 && <NotHaveInfo />}
            </div>
            {totalItems > itemsPerPage && (
                <Pagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                    themeColor={themeColor}
                />
            )}
            <Modal
                open={isModalOpen}
                centered
                width={1200}
                closable={false}
                footer={null}
            >
                <div className="plan-content">
                    <div className='plan-content-header'>
                        <div>{complateServiceInfo}</div>
                        <CloseCircleOutlined onClick={() => {
                            setIsModalOpen(false);
                            setCurrentProduct(null);
                        }} style={{ fontSize: "35px", cursor: "pointer" }} />
                    </div>
                    <div className='plan-line'></div>
                    <div className='plan-info'>
                        <span>{serviceName}:</span>
                        <span style={{ color: themeColor }}>{currentProduct?.commodityOtherName || notnone}</span>
                    </div>
                    <div className='plan-info'>
                        <span>{serviceVersion}:</span>
                        <span style={{ color: themeColor }}>{currentProduct?.commodityName || notnone}</span>
                    </div>
                    <div className='plan-info'>
                        <span>{serviceType}:</span>
                        <span style={{ color: themeColor }}>{currentProduct?.commodityType || notnone}</span>
                    </div>
                    <div className='plan-line'></div>
                    <Button
                        onClick={addProduct}
                        style={{
                            borderRadius: '18px',
                            marginTop: "0",
                            backgroundColor: themeColor,
                            boxShadow: `0 2px 4px 0 ${themeColor}`,
                            color: '#fff',
                            border: 'none',
                            width: "160px",
                            height: "36px"
                        }}
                    >
                        {upload}
                    </Button>
                    <div style={{ marginTop: '16px', fontSize: "14px", color: "#33364b" }}>
                        {taps}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ChooseCompany;